import { Outlet } from 'react-router-dom'
import SimpleNavTabs, { Tab } from '@/common/components/SimpleNavTabs.tsx'
import { AppRoutePaths } from '../../../routing/route_paths.ts'

const Paths = AppRoutePaths.setup
const Tabs: Tab[] = [
  { name: 'Program', href: Paths.program.index, privilege: 'programs_read' },
  { name: 'Users', href: Paths.users.index, privilege: 'users_read' },
  { name: 'Roles', href: Paths.roles.index, privilege: 'roles_read' },
  { name: 'Provider Categories', href: Paths.provider_categories.index },
  {
    name: 'System Catalog',
    href: Paths.systemCatalog.index,
    privilege: 'roles_create',
  },
  {
    name: 'Payment Approval Rules',
    href: Paths.category_and_product_rules.index,
    privilege: 'roles_create',
  },
  { name: 'Links', href: Paths.help_links.index, privilege: 'roles_create' },
  {
    name: 'Provider Affiliations',
    href: Paths.provider_affiliations.index,
    privilege: 'provider_management_read',
  },
  {
    name: 'Bank Accounts',
    href: Paths.bank_accounts.index,
    privilege: 'setup_bank_accounts_program_purses_read',
  },
  {
    name: 'Message Queue Logs',
    href: Paths.message_queue_logs.index,
    privilege: 'message_queue_logs_read',
  },
]

export default function SetupPage() {
  return (
    <div className="flex flex-col">
      <SimpleNavTabs tabs={Tabs} />
      <Outlet />
    </div>
  )
}
